/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'form-builder.QuestionType.ChoiceCascadingLabel': 'Cascading dropdown',
  'form-builder.QuestionType.ChoiceDropdownLabel': 'Dropdown',
  'form-builder.QuestionType.ChoiceDropdownMultipleLabel': 'Multiselect dropdown',
  'form-builder.QuestionType.ChoiceMultipleLabel': 'Checkboxes',
  'form-builder.QuestionType.ChoiceQuestionsGroupLabel': 'Choice fields',
  'form-builder.QuestionType.ChoiceSingleLabel': 'Radio buttons',
  'form-builder.QuestionType.CmdbObjectLabel': 'Assets object/s',
  'form-builder.QuestionType.DateLabel': 'Date',
  'form-builder.QuestionType.DateQuestionsGroupLabel': 'Date fields',
  'form-builder.QuestionType.DateTimeLabel': 'Date & Time',
  'form-builder.QuestionType.NumberLabel': 'Number',
  'form-builder.QuestionType.NumericQuestionsGroupLabel': 'Numeric fields',
  'form-builder.QuestionType.PlainTextParagraphLabel': 'Paragraph (Plain text)',
  'form-builder.QuestionType.RichTextParagraphLabel': 'Paragraph',
  'form-builder.QuestionType.TextAttachmentLabel': 'Attachment',
  'form-builder.QuestionType.TextEmailLabel': 'Email',
  'form-builder.QuestionType.TextLongLabel': 'Long text',
  'form-builder.QuestionType.TextParagraphLabel': 'Paragraph',
  'form-builder.QuestionType.TextQuestionsGroupLabel': 'Text fields',
  'form-builder.QuestionType.TextShortLabel': 'Short text',
  'form-builder.QuestionType.TextUrlLabel': 'URL',
  'form-builder.QuestionType.TimeLabel': 'Time',
  'form-builder.QuestionType.UnsupportedLabel': 'Unsupported',
  'form-builder.QuestionType.UserMultipleLabel': 'Multiple users',
  'form-builder.QuestionType.UserQuestionsGroupLabel': 'User fields',
  'form-builder.QuestionType.UserSingleLabel': 'Single user',
  'form-system.ChoiceQuestion.NewOptionPlaceholder': 'New option...',
  'form-system.ChoiceQuestion.OtherPlaceholder': 'Other...',
  'form-system.ChoiceQuestion.SelectPlaceholder': 'Select...',
  'form-system.DateQuestion.DatePlaceholder': 'e.g. {date}',
  'form-system.JiraField.ChoiceMultipleLabel': 'Multiple choice',
  'form-system.JiraField.ChoiceSingleLabel': 'Single choice',
  'form-system.JiraField.NoneLabel': 'Unknown',
  'form-system.JiraField.ParagraphLabel': 'Paragraph',
  'form-system.JiraField.TextLabel': 'Text',
  'form-system.JiraField.UnsupportedLabel': 'Unknown',
  'form-system.TimeQuestion.TimePlaceholder': 'e.g. {time}',
  'form-system.UserPicker.UserPickerStartTyping': 'Start typing to search for users',
  'form-system.choice-dropdown.loading': 'Loading...',
  'form-system.choice-dropdown.new-option': 'New option...',
  'form-system.choice-dropdown.no-options': 'No options',
  'form-system.choice-dropdown.select': 'Select...',
  'form-system.date-time.date.label': 'Date : {label}',
  'form-system.date-time.time.label': 'Time : {label}',
  'form-system.general.Add': 'Add',
  'form-system.general.All': 'All',
  'form-system.general.And': 'And',
  'form-system.general.Back': 'Back',
  'form-system.general.Cancel': 'Cancel',
  'form-system.general.Change': 'Change',
  'form-system.general.Close': 'Close',
  'form-system.general.Copy': 'Copy',
  'form-system.general.Create': 'Create',
  'form-system.general.CreateAnother': 'Create another',
  'form-system.general.CreateForm': 'Create Form',
  'form-system.general.Delete': 'Delete',
  'form-system.general.Download': 'Download',
  'form-system.general.Edit': 'Edit',
  'form-system.general.Export': 'Export',
  'form-system.general.Json': 'JSON',
  'form-system.general.Loading': 'Loading',
  'form-system.general.LoadingAvailableForms': 'Loading available forms',
  'form-system.general.LoadingForm': 'Loading form',
  'form-system.general.LoadingFormDetails': 'Loading form details',
  'form-system.general.Next': 'Next',
  'form-system.general.Of': 'of',
  'form-system.general.Prev': 'Prev',
  'form-system.general.Project': 'Project',
  'form-system.general.Reopen': 'Reopen',
  'form-system.general.Save': 'Save',
  'form-system.general.Saved': 'Saved',
  'form-system.general.Search': 'Search',
  'form-system.general.Showing': 'Showing',
  'form-system.general.Submit': 'Submit',
  'form-system.general.SubmitSave': 'Save and submit',
  'form-system.general.Templates': 'Templates',
  'form-system.general.Upgrade': 'Upgrade',
  'form-system.general.View': 'View',
  'form-system.general.Xlsx': 'XLSX',
  'form-system.headerBar.emptyFormName': 'Untitled Form',
  'form-system.renderQuestion.read-only-reason-anonymous-message': 'Log in with a valid account to access this field.',
  'form-system.renderQuestion.read-only-reason-unlicensed-message':
    'This field is only available to users with Jira access.',
  'form-system.unknown-question-type': "We couldn't load the <strong>{questionType}</strong> field type at this time.",
  'form-system.validationErrorMsg.Required': 'This field is required.',
  'form-system.validationErrorMsg.RequiredWithLabel': '{fieldLabel} is required.',
  'form-system.validationErrorMsg.choice.BetweenChoices': 'Choose between {mns} and {mxs}.',
  'form-system.validationErrorMsg.choice.ExactChoices': 'Choose exactly {mns}.',
  'form-system.validationErrorMsg.choice.MaxChoices': 'Choose no more than {mxs}.',
  'form-system.validationErrorMsg.choice.MinChoices': 'Choose at least {mns}.',
  'form-system.validationErrorMsg.choice.ReqChoice': 'The ‘{label}’ choice is required.',
  'form-system.validationErrorMsg.datetime.BetweenDate':
    'The date must be between {mnd, date, medium} and {mxd, date, medium}.',
  'form-system.validationErrorMsg.datetime.BetweenDateTime':
    'The date and time must be between the {mnd, date, medium} at {mnt, time, short} and the {mxd, date, medium} at {mxt, time, short}.',
  'form-system.validationErrorMsg.datetime.BetweenTime':
    'The time must be between {mnt, time, short} and {mxt, time, short}.',
  'form-system.validationErrorMsg.datetime.ExactDate': 'The date must be exactly {mnd, date, medium}.',
  'form-system.validationErrorMsg.datetime.ExactDateTime':
    'The date and time must be exactly the {mnd, date, medium} at {mnt, time, short}.',
  'form-system.validationErrorMsg.datetime.ExactTime': 'The time must be exactly {mnt, time, short}.',
  'form-system.validationErrorMsg.datetime.InvalidTime': 'The time is invalid.',
  'form-system.validationErrorMsg.datetime.MaxDate': 'The date must be on or before {mxd, date, medium}.',
  'form-system.validationErrorMsg.datetime.MaxDateTime':
    'The date and time must be on or before the {mxd, date, medium} at {mxt, time, short}.',
  'form-system.validationErrorMsg.datetime.MaxTime': 'The time must be at or before {mxt, time, short}.',
  'form-system.validationErrorMsg.datetime.MinDate': 'The date must be on or after {mnd, date, medium}.',
  'form-system.validationErrorMsg.datetime.MinDateTime':
    'The date and time must be on or after the {mnd, date, medium} at {mnt, time, short}.',
  'form-system.validationErrorMsg.datetime.MinTime': 'The time must be at or after {mnt, time, short}.',
  'form-system.validationErrorMsg.datetime.RequiredDateTime': 'This field is required. Please specify a date and time.',
  'form-system.validationErrorMsg.datetime.RequiredDateTimeWithLabel':
    '{fieldLabel} is required. Please specify a date and time.',
  'form-system.validationErrorMsg.number.BetweenNum': 'Must be between {mnn} and {mxn}.',
  'form-system.validationErrorMsg.number.ExactNum': 'Must be exactly {mnn}.',
  'form-system.validationErrorMsg.number.InvalidNum': 'Please enter a valid number.',
  'form-system.validationErrorMsg.number.MaxNum': 'Must be less than or equal to {mxn}.',
  'form-system.validationErrorMsg.number.MinNum': 'Must be more than or equal to {mnn}.',
  'form-system.validationErrorMsg.number.WholeNum': 'Must be a whole number.',
  'form-system.validationErrorMsg.text.BetweenChars':
    'Must be between {mnc} and {mxc, plural, one {# character} other {# characters}}.',
  'form-system.validationErrorMsg.text.BetweenWords':
    'Must be between {mnw} and {mxw, plural, one {# word} other {# words}}.',
  'form-system.validationErrorMsg.text.ExactChars':
    'Must be exactly {mnc, plural, one {# character} other {# characters}}.',
  'form-system.validationErrorMsg.text.ExactWords': 'Must be exactly {mnw, plural, one {# word} other {# words}}.',
  'form-system.validationErrorMsg.text.InvalidEmail': 'Must be an email address',
  'form-system.validationErrorMsg.text.InvalidUrl': 'Must be a valid URL e.g. https://www.google.com/images',
  'form-system.validationErrorMsg.text.MaxChars':
    'Must be less than {mxc, plural, one {# character} other {# characters}}.',
  'form-system.validationErrorMsg.text.MaxWords': 'Must be less than {mxw, plural, one {# word} other {# words}}.',
  'form-system.validationErrorMsg.text.MinChars':
    'Must be more than {mnc, plural, one {# character} other {# characters}}.',
  'form-system.validationErrorMsg.text.MinWords': 'Must be more than {mnw, plural, one {# word} other {# words}}.',
  'form-system.validationErrorMsg.text.RegexCustomMsg': '{message}',
  'form-system.validationErrorMsg.text.RegexDefaultMsg': 'Response does not match required pattern.',
  'form-system.validationErrorMsg.text.RegexInvalidMsg':
    'The regex pattern on this field is invalid. Answer unable to be validated.',
  'form-system.validationErrorMsg.userpicker.BetweenChoices':
    'Choose between {mns} and {mxs, plural, one {# user} other{# users}}.',
  'form-system.validationErrorMsg.userpicker.ExactChoices':
    'Choose exactly {mns, plural, one {# user} other {# users}}.',
  'form-system.validationErrorMsg.userpicker.MaxChoices':
    'Choose no more than {mxs, plural, one {# user} other {# users}}.',
  'form-system.validationErrorMsg.userpicker.MinChoices':
    'Choose at least {mns, plural, one {# user} other {# users}}.',
  'form-system.viewForm.HiddenSection': 'Hidden section - Conditions apply',
  'proforma-common-core.form-system.components.questions.cascading-dropdown.edit.choice-dropdown-no-options':
    'No options',
  'proforma-common-core.form-system.components.questions.cascading-dropdown.edit.choice-dropdown-select': 'Select...',
  'proforma-common-core.jira-common.models.jira-field.choice-cascading-label': 'Cascading choice',
  'proforma-form-builder.src.components.questiontypes.linked-field-icon.tooltip': 'Linked to ‘{fieldName}‘ Jira field',
  'proforma-form-builder.src.components.questiontypes.linked-field-icon.unknown-field': 'Linked to Jira field',
  'ui-notices.apiError.msg.AddConnectionFailedMsg': 'A server error occurred while trying to add the data connection.',
  'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg':
    'A server error occurred while trying to load data connections on the template form.',
  'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg':
    'A server error occurred while trying to load Jira fields on the template form.',
  'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg':
    "A server error occurred while trying to load the reference for the template form's settings.",
  'ui-notices.apiError.msg.LoadTemplateFormFailedMsg': 'Refresh the page to try again',
  'ui-notices.apiError.msg.MissingPermissionsMsg':
    'You do not have the necessary permissions to perform this action. Please contact your Jira Administrator.',
  'ui-notices.apiError.msg.SaveFormFailedMsg': 'A server error occurred while trying to save the form.',
  'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg':
    'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
  'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg':
    'Resolve any invalid answers and check all required fields are complete.',
  'ui-notices.apiError.msg.SaveTemplateFormFailedMsg':
    'A server error occurred while trying to save the template form.',
  'ui-notices.apiError.msg.SubmitFormFailedMsg': 'A server error occurred while trying to submit the form.',
  'ui-notices.apiError.msg.UnauthorisedMsg': 'Try refreshing your page or logging into Jira again.',
  'ui-notices.apiError.msg.UpdateConnectionFailedMsg':
    'A server error occurred while trying to update the data connection.',
  'ui-notices.apiError.title.AddConnectionFailedTitle': 'Error: Adding data connection failed',
  'ui-notices.apiError.title.LoadDataConnectionsFailedTitle': 'Error: Loading data connections failed.',
  'ui-notices.apiError.title.LoadJiraFieldsFailedTitle': 'Error: Loading Jira fields failed',
  'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle': 'Error: Loading form settings reference data failed.',
  'ui-notices.apiError.title.LoadTemplateFormFailedTitle': 'We couldn’t load your form',
  'ui-notices.apiError.title.MissingPermissionsTitle': 'Error: User is not allowed this action',
  'ui-notices.apiError.title.SaveFormFailedTitle': 'We couldn’t save your changes',
  'ui-notices.apiError.title.SaveTemplateFormFailedTitle': 'Error: Saving template form failed',
  'ui-notices.apiError.title.SubmitFormFailedTitle': 'Error: Submitting form failed',
  'ui-notices.apiError.title.UnauthorisedTitle': 'Error: User Unauthorised',
  'ui-notices.apiError.title.UpdateConnectionFailedTitle': 'Error: Updating data connection failed',
  'ui-notices.confirmText.Cancel': 'Cancel',
  'ui-notices.confirmText.Change': 'Change',
  'ui-notices.confirmText.Close': 'Close',
  'ui-notices.confirmText.Confirm': 'Confirm',
  'ui-notices.confirmText.Delete': 'Delete',
  'ui-notices.confirmText.Discard': 'Discard',
  'ui-notices.confirmText.MakeExternal': 'Make external',
  'ui-notices.confirmText.MakeInternal': 'Make internal',
  'ui-notices.confirmText.Reopen': 'Reopen',
  'ui-notices.confirmText.Submit': 'Submit',
  'ui-notices.confirmText.UpgradeNow': 'Upgrade Now',
  'ui-notices.msg.CancelEditFormMsg':
    'There are changes to answers on the “{formName}” form that will be lost if you choose "Confirm". Are you sure you want to continue?',
  'ui-notices.msg.ChangeFormInternalMsg':
    'Any forms made internal will only be seen by agents and hidden in the portal from customers.',
  'ui-notices.msg.ChangeFormToExternalMsg':
    'Customers will be able to view this form in the portal and it will no longer be internal only.',
  'ui-notices.msg.DeleteFormMsg': 'Are you sure you want to delete the “{formName}” form? This cannot be undone.',
  'ui-notices.msg.ErrorExplanations1': 'Please refer to our',
  'ui-notices.msg.ErrorExplanations2': 'Error Explanations',
  'ui-notices.msg.ErrorExplanations3': 'page for more details or contact',
  'ui-notices.msg.ErrorExplanations4': 'ThinkTilt Support',
  'ui-notices.msg.ReopenFormMsg': 'Are you sure you want to reopen the submitted form for editing?',
  'ui-notices.msg.SubmitFormLockMsg':
    'Are you sure you want to submit this form ? Once submitted no further changes can be made.',
  'ui-notices.msg.SubmitFormMsg': 'Are you sure you want to submit this form ?',
  'ui-notices.title.CancelEditFormTitle': 'Confirm Discarding Changes',
  'ui-notices.title.ChangeFormAvailabilityTitle': 'Confirm Changing Form Availability',
  'ui-notices.title.ChangeFormInternalHeader': 'Make form internal only and hide from customer',
  'ui-notices.title.ChangeFormToExternalHeader': 'Make form external and show to customer',
  'ui-notices.title.DeleteFormTitle': 'Confirm Deleting Form',
  'ui-notices.title.ReopenFormTitle': 'Confirm Reopening Form',
  'ui-notices.title.SubmitFormTitle': 'Confirm Form Submission',
};
